<script lang="ts">
	import type { OperationModel } from '@app/models/api/OperationModel';
	import ProjectContentLayout from '../elements/ProjectContentLayout.svelte';
	import ProjectSocialBox from '../elements/ProjectSocialShareBox.svelte';
	import ProjectTestimoniesBox from '../elements/ProjectTestimoniesBox.svelte';
	import FundsTabs from '../tabs/FundsTabs.svelte';
	import ProjectImportantInformation from '../elements/ProjectImportantInformation.svelte';
	import { OperationStatusEnum } from '@app/models/api/enums/OperationStatusEnum';
	import type { ButtonBoxType } from '@wiseed/wikit';
	import ProjectErrorBox from '../elements/ProjectErrorBox.svelte';
	import ButtonVote from '@app/components/ButtonVote.svelte';
	import ButtonInvest from '@app/components/ButtonInvest.svelte';
	import ProjectKeyPoints from '../ProjectKeyPoints.svelte';
	import ProjectRisk from '@app/components/projects/elements/ProjectRisk.svelte';
	import { page } from '$app/stores';
	import { operationCanBeVoted } from '@app/utils/operations';

	export let slug: string = null;
	export let operation: OperationModel;

	let props: ButtonBoxType = {
		classNames: 'w-full flex justify-center',
		disabled: false
	};

	let voteModal;

	const loadVoteModal = async () => {
		try {
			let { default: Modal } = await import('../ProjectVoteModal.svelte');
			if (Modal) {
				voteModal = Modal;
			}
		} catch (e) {
			console.error(e);
		}
	};

	const closeVoteModal = () => {
		voteModal = null;
	};
</script>

<ProjectContentLayout>
	<svelte:fragment slot="left-col">
		<FundsTabs {operation} {slug} />
	</svelte:fragment>
	<svelte:fragment slot="right-col">
		{#if operation.status?.includes(OperationStatusEnum.FUNDING)}
			{#if operation.investErrors?.length}
				<ProjectErrorBox {operation} />
			{/if}
			<ButtonInvest {operation} bind:props />
		{/if}
		{#if operationCanBeVoted(operation)}
			<ButtonVote openModal={loadVoteModal} />
		{/if}
		{#if $page?.data?.user}<ProjectKeyPoints {operation} />{/if}
		<ProjectImportantInformation {operation} />
		<ProjectRisk {operation} />
		<ProjectTestimoniesBox operationId={operation.id} />
		<ProjectSocialBox {operation} />
	</svelte:fragment>
</ProjectContentLayout>

<svelte:component
	this={voteModal}
	{operation}
	on:closeModal={() => closeVoteModal()}
	note={operation.userVote}
/>
